import React, { FC } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { QUICK_SERIES_INNER_BASE } from "../../utils/menuPathNormalize";

/** 旧书签 `/quickSeriesListIn?...` → 工作台内规范路径 */
export const QuickSeriesListInLegacyRedirect: FC = () => {
  const [sp] = useSearchParams();
  const qs = sp.toString();
  return <Navigate to={qs ? `${QUICK_SERIES_INNER_BASE}?${qs}` : QUICK_SERIES_INNER_BASE} replace />;
};
